import { render, staticRenderFns } from "./IDMLPreview.vue?vue&type=template&id=23cd7028&scoped=true"
import script from "./IDMLPreview.vue?vue&type=script&lang=js"
export * from "./IDMLPreview.vue?vue&type=script&lang=js"
import style0 from "./IDMLPreview.vue?vue&type=style&index=0&id=23cd7028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cd7028",
  null
  
)

export default component.exports